"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDateDatasetsForInsight = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var configSelectors_1 = require("../store/config/configSelectors");
var effects_1 = require("redux-saga/effects");
/**
 * This generator function will communicate with backend to obtain the available date data sets that can be
 * used for date-filtering of the provided insight.
 *
 * The available date datasets vary based on the contents (measures, attributes) of the insight & the shape of
 * the LDM itself. Some data sets will not be available as they are unreachable given the measures/attributes
 * used in the insight.
 *
 * This generator will take into account the current object availability config.
 *
 * @param ctx - dashboard context in which the resolution should be done
 * @param insight - insight to use during availability check
 */
function loadDateDatasetsForInsight(ctx, insight) {
    var backend, workspace, availability, catalogLoader, catalog, availableDateDataSetsLoader, loadedAvailableDateDataSets;
    var _a, _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                backend = ctx.backend, workspace = ctx.workspace;
                return [4 /*yield*/, effects_1.select(configSelectors_1.selectObjectAvailabilityConfig)];
            case 1:
                availability = _c.sent();
                catalogLoader = backend.workspace(workspace).catalog();
                return [4 /*yield*/, effects_1.call([
                        catalogLoader,
                        catalogLoader.load,
                    ])];
            case 2:
                catalog = _c.sent();
                availableDateDataSetsLoader = catalog.availableItems().withOptions({
                    types: ["dateDataset"],
                    insight: insight,
                    excludeTags: ((_a = availability.excludeObjectsWithTags) !== null && _a !== void 0 ? _a : []).map(function (tag) { return sdk_model_1.idRef(tag); }),
                    includeTags: ((_b = availability.includeObjectsWithTags) !== null && _b !== void 0 ? _b : []).map(function (tag) { return sdk_model_1.idRef(tag); }),
                });
                return [4 /*yield*/, effects_1.call([availableDateDataSetsLoader, availableDateDataSetsLoader.load])];
            case 3:
                loadedAvailableDateDataSets = _c.sent();
                /*
                 * You may also remember from KD that the code was cleaning up the relevance values from the available date
                 * datasets. This was there to carefully align data to get feasible results from the `getRecommendedDateDataset`
                 */
                return [2 /*return*/, loadedAvailableDateDataSets.availableDateDatasets()];
        }
    });
}
exports.loadDateDatasetsForInsight = loadDateDatasetsForInsight;
//# sourceMappingURL=loadAvailableDateDatasets.js.map